import React, { FC, useMemo, useState } from "react"
import BlockTitle from "../BlockTitle"
import "./index.scss"
type TBlockProps = {
  title?: string
  className?: string
  subTitle?: string
  tabs?: React.ComponentElement<any, any>
  theme?: string
  closable?: boolean
}
const Block: FC<TBlockProps> = ({
  theme = "default",
  tabs,
  className,
  title,
  subTitle,
  children,
  closable,
}) => {
  const [collapse, setCollapse] = useState(false)
  const klassName = useMemo(() => {
    let cs = ["block", "theme-" + theme]
    if (className) {
      cs.push(className)
    }
    if (collapse) {
      cs.push("collapse")
    }
    return cs.join(" ")
  }, [theme, className, collapse])
  const titleRes = useMemo(() => {
    if (!title) return null
    if (theme === "2") {
      return (
        <BlockTitle
          title={title}
          closable={closable && !collapse}
          bgColor="rgba(27, 128, 132, 0.94)"
          lineColor="#00FFFB"
          onClose={() => setCollapse(!collapse)}
        />
      )
    }
    return (
      <div className="block-title">
        <span>{title}</span>
      </div>
    )
  }, [title, theme, closable, collapse])
  if (collapse) {
    return (
      <div className={klassName}>
        <div className="block-inner" onClick={() => setCollapse(false)}>
          {titleRes}
        </div>
      </div>
    )
  }
  return (
    <div className={klassName}>
      <div className="block-inner">
        {titleRes}
        {subTitle ? <div className="block-sub-title">{subTitle}</div> : null}
        <div className="block-body">
          {tabs}
          <div className="block-body-inner">{children}</div>
        </div>
      </div>
    </div>
  )
}
export default Block
